import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const StatutApprenti = [
  'Permanent',
  'Interimaire',
] as const

export type StatutApprenti = typeof StatutApprenti[number]

export const StatutApprentiLibelle: UnionTypeLibelle<StatutApprenti> = {
  Permanent: 'Permanent',
  Interimaire: 'Intérimaire',
} as const
